export function defaultFilters() {
    return {
        dateRange: 'last90days',   // 'last30days', 'last90days', 'ytd', 'custom'
        startDate: null,           // used if dateRange === 'custom'
        endDate: null,
        loanPurpose: [],           // ['purchase', 'refi']
        loanType: [],              // ['conventional', 'fha', 'va']
        loanSource: [],           // ['realtor', 'past_client']
        referralSource: [],       // ['john_doe', 'abc_team']
        state: [],
        county: [],
        city: [],
        zip: [],
        minPurchasePrice: '',
        maxPurchasePrice: '',
        minLoanAmount: '',
        maxLoanAmount: '',
        minInterestRate: '',
        maxInterestRate: ''
    };
}
  